(function () {
  var BRAND = /^(brand|vendor|brands)$/i;
  function letterOf(t) {
    var c = (t || '').trim().charAt(0).toUpperCase();
    try { c = c.normalize('NFD').replace(/[̀-ͯ]/g, ''); } catch (e) {}
    return /[A-Z]/.test(c) ? c : '#';
  }
  function enhance(widget) {
    if (widget.getAttribute('data-uc-brand')) return;
    var list = widget.querySelector('ul.m-facets');
    if (!list) return;
    widget.setAttribute('data-uc-brand', '1');
    var items = Array.prototype.slice.call(list.querySelectorAll(':scope > li.m-facet--item'));
    if (!items.length) return;
    var txt = function (li) { var l = li.querySelector('.m-facet--label'); return l ? l.textContent.trim() : li.textContent.trim(); };
    items.sort(function (a, b) {
      var la = letterOf(txt(a)), lb = letterOf(txt(b));
      if (la === '#' && lb !== '#') return 1;
      if (lb === '#' && la !== '#') return -1;
      return txt(a).localeCompare(txt(b), undefined, { sensitivity: 'base' });
    });
    list.innerHTML = '';
    var cur = '';
    items.forEach(function (li) {
      var L = letterOf(txt(li));
      if (L !== cur) {
        cur = L;
        var h = document.createElement('li');
        h.className = 'uc-letter';
        h.textContent = L;
        list.appendChild(h);
      }
      list.appendChild(li);
    });
    var wrap = document.createElement('div');
    wrap.className = 'uc-brand-search';
    wrap.innerHTML = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="11" cy="11" r="7"/><path d="M20 20l-4-4"/></svg><input type="text" placeholder="Search ' + items.length + ' brands" aria-label="Search brands">';
    list.parentNode.insertBefore(wrap, list);
    var input = wrap.querySelector('input');
    input.addEventListener('input', function () {
      var q = input.value.trim().toLowerCase();
      var lastHead = null, any = false;
      Array.prototype.forEach.call(list.children, function (el) {
        if (el.classList.contains('uc-letter')) {
          if (lastHead) lastHead.style.display = any ? '' : 'none';
          lastHead = el; any = false;
        } else {
          var show = !q || txt(el).toLowerCase().indexOf(q) !== -1;
          el.style.display = show ? '' : 'none';
          if (show) any = true;
        }
      });
      if (lastHead) lastHead.style.display = any ? '' : 'none';
    });
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') e.preventDefault(); });
  }
  function scan() {
    document.querySelectorAll('.m-filter--widget').forEach(function (w) {
      var t = w.querySelector('.m-filter--widget-title');
      if (t && BRAND.test(t.textContent.trim())) enhance(w);
    });
  }
  var timer;
  var mo = new MutationObserver(function () { clearTimeout(timer); timer = setTimeout(scan, 60); });
  function start() { scan(); mo.observe(document.body, { childList: true, subtree: true }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
